var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React from 'react';
import { FaChevronRight, FaFolder, FaFolderOpen, FaRegFilePdf } from 'react-icons/fa';
import { FiShield } from 'react-icons/fi';
import { ModalPdf } from '@app/components/modal-pdf';
import { TipoArquivo } from '@app/utils/arquivo.utils';
import { Breadcrumb, EmptyState, IconTile, ListCard, SectionLabel } from '@atomic/v3';
import { FileLibraryContainer } from './file-library.component.style';
import { BIBLIOTECA_ARQUIVOS_URL, TITULO_BIBLIOTECA_ARQUIVOS, } from './file-library.model';
var quantidade = function (total, singular, plural) { return total + " " + (total === 1 ? singular : plural); };
var resumoPasta = function (pasta) {
    return [
        pasta.pastas.length ? quantidade(pasta.pastas.length, 'pasta', 'pastas') : '',
        pasta.arquivos.length ? quantidade(pasta.arquivos.length, 'arquivo', 'arquivos') : '',
    ]
        .filter(Boolean)
        .join(' · ');
};
export var FileLibrary = function (_a) {
    var pastas = _a.pastas, caminho = _a.caminho, onAbrirPasta = _a.onAbrirPasta, onIrParaNivel = _a.onIrParaNivel;
    var _b = React.useState(), arquivoAberto = _b[0], setArquivoAberto = _b[1];
    var pastaAtual = caminho[caminho.length - 1];
    var pastasVisiveis = pastaAtual ? pastaAtual.pastas : pastas;
    var arquivosVisiveis = pastaAtual ? pastaAtual.arquivos : [];
    var exibirRotulos = pastasVisiveis.length > 0 && arquivosVisiveis.length > 0;
    if (!pastaAtual && pastas.length === 0) {
        return (React.createElement(EmptyState, { icon: React.createElement(FaFolderOpen, null), title: "Nenhum arquivo dispon\u00EDvel para voc\u00EA no momento.", description: "Quando a sua empresa compartilhar arquivos com voc\u00EA, eles aparecem aqui." }));
    }
    return (React.createElement(FileLibraryContainer, null,
        caminho.length > 0 && (React.createElement(Breadcrumb, { items: __spreadArrays([
                { label: TITULO_BIBLIOTECA_ARQUIVOS, onClick: function () { return onIrParaNivel(0); } }
            ], caminho.map(function (pasta, indice) { return ({ label: pasta.nome, onClick: function () { return onIrParaNivel(indice + 1); } }); })) })),
        exibirRotulos && React.createElement(SectionLabel, null, "Pastas"),
        pastasVisiveis.map(function (pasta) { return (React.createElement(ListCard, { key: "pasta-" + pasta.id, leading: React.createElement(IconTile, null,
                React.createElement(FaFolder, null)), title: pasta.nome, subtitle: resumoPasta(pasta), trailing: React.createElement(FaChevronRight, null), onClick: function () { return onAbrirPasta(pasta); } })); }),
        exibirRotulos && React.createElement(SectionLabel, null, "Arquivos"),
        arquivosVisiveis.map(function (arquivo) { return (React.createElement(ListCard, { key: "arquivo-" + arquivo.id, leading: React.createElement(IconTile, { variant: "pdf" },
                React.createElement(FaRegFilePdf, null)), title: arquivo.titulo, subtitle: React.createElement(React.Fragment, null,
                React.createElement(FiShield, { "aria-hidden": "true" }),
                "PDF protegido"), onClick: function () { return setArquivoAberto(arquivo); } })); }),
        arquivoAberto && (
        // Leitor protegido existente (5320), lendo o PDF pelo endpoint da biblioteca.
        React.createElement(ModalPdf, { arquivo: { id: arquivoAberto.id, tipoArquivo: TipoArquivo.PdfProtegido }, endpoint: BIBLIOTECA_ARQUIVOS_URL + "/arquivo/" + arquivoAberto.id, onClose: function () { return setArquivoAberto(undefined); } }))));
};
